import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import useGetAllData from '../../hooks/useGetAllData';
import './style.css';
import { useSelectedItem } from '../../context/selectedItemContext';
import { ICategories } from '../../models/categories';

const { SubMenu } = Menu;

const ArbitratorsSidebar: React.FC = () => {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const { setSelectedItemName, setSpecializations } = useSelectedItem();

  const location = useLocation();

  const { data: categories } = useGetAllData<ICategories[]>({
    queryKey: ["categories_all"],
    url: "categories",
    urlParams: {'disabled': true}
  });

  const findOpenKeysByPath = (categories: any[], path: string): string[] => {
    let keys: string[] = [];

    const findKeys = (items: any[], parentKey: string[] = []): boolean => {
      for (const item of items) {
        const currentKey = [...parentKey, item.id.toString()];
        if (item.path === path || path.includes(`${item.path}/:${item.id}`)) {
          keys = currentKey;
          setSelectedItemName(item.name); // category nameni contextga saqlash
          setSpecializations(item.specializations || null); //categoryni setSpecializations ni contextga saqlash
          return true;
        }
        if (item.children && findKeys(item.children, currentKey)) {
          return true;
        }
      }
      return false;
    };

    findKeys(categories);
    return keys;
  };

  useEffect(() => {
    if (categories) {
      const path = location.pathname;
      const keys = findOpenKeysByPath(categories, path);
      setSelectedKeys([keys[keys.length - 1]]);
      setOpenKeys(keys.slice(0, keys.length - 1));
    }
  }, [location.pathname, categories]);

  const handleOpenChange = (keys: string[]) => {
    const rootSubmenuKeys = categories.map((item: any) => item.id.toString());
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const renderMenuItems = (items: any[]) => {
    return items.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
          <SubMenu key={item.id} title={item.name}>
            {renderMenuItems(item.children)}
          </SubMenu>
        );
      }

      return (
        <>
            {
                item?.path === '/' ? null : <Menu.Item 
                key={item.id}
                style={{
                  background: location.pathname === `${item.path}/:${item.id}` ? '#29487E' : location?.pathname == item?.path ? '#29487E'  : '',
                  color: location.pathname === `${item.path}/:${item.id}` ? 'white' : location?.pathname == item?.path ? 'white' :  '#29487E',
                  borderRadius: 0,
                  borderTopLeftRadius: '10px',
                  borderBottomLeftRadius: '10px',
                  fontSize:'18px',
                  fontWeight: 400,
                  fontFamily: 'IBM Plex Sans'
                }}
              >
                <Link key={item?.path} to={item?.path === '/calculator' ? '/calculator' : item?.path === '/contact' ? '/contact' : item?.path === '/contact-us' ? '/contact-us' : `${item.path}/:${item.id}`}>
                  {item.name}
                </Link>
              </Menu.Item>
            }
        </>
      );
    });
  };

  return (
    <div className="arbitors_sidebar max-lg:hidden border-r-2 border-main_color">
      <Menu
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        style={{ height: '100%', background: 'white', width: '350px', paddingTop: '20px' }}
      >
        {categories && renderMenuItems(categories)}
      </Menu>
    </div>
  );
};

export default ArbitratorsSidebar;


// #################################################################################################



